
@for (checkoutPage of checkoutPagesRetrieved; track checkoutPage.name) {
  <app-checkout
    [sourceLandingPageId]="checkoutPage.sourceLandingPageId"
    [title]="checkoutPage.name"
    [options]="checkoutPage.rentalOptions"
    [vehicleTypes]="checkoutPage.vehicleTypes"
    (checkoutError)="onCheckoutError($event)"
  />
}

@if (errorMessage) {
  <p>{{ errorMessage }}</p>
}

@if (devMode)
{
  <div class="dev-help">
    <p>landing-page works!</p>
    <p>snapshot landing-page: {{landingPageId}}</p>
    <p>snapshot context-session-id: {{contextSessionId}}</p>
    <div>
      <p>Cookies:</p>
      @for (entry of allCookies; track entry.key) {
        <p>&nbsp;&nbsp;&nbsp;&nbsp;{{ entry.key }}: {{ entry.value }}</p>
      }
    </div>
    <button>bttn</button>
    <p>Checkout pages retrieved:</p>
    <pre>{{checkoutPagesRetrieved | json}}</pre>
  </div>
}